import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from './../service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,private toastr: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.authlogout();
                location.reload(true);
            } else if (err.status == 422) {
                 //console.log(err.error);
                if(err.error.message){
                    this.toastr.error(err.error.message);
                }else{
                    for (let key in err.error) {
                        this.toastr.error(err.error[key]);
                      }
                }
               
              }
              else if (err.status == 500) {
                //console.log(err.error);
             this.toastr.error('Internal Server Error');
              
              
             }
              


            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}